import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { getPatientGeneralDetails } from "../../services/patient/details";
import { useQuery } from "@tanstack/react-query";
import styles from "../../styles/patient-page-modules/GeneralDetails.module.css";
import Spinner from "../spinner";
import { useSearchParams } from "react-router-dom";
import Reload from "../ui/reload-data";
import { formatDate, formatDob } from "../../utils/helper";

const GeneralDetails = ({ patientContacts }) => {
  const primaryContact = patientContacts?.find(
    (contact) => contact.label.toLowerCase() === "primary"
  );
  const secondaryContact = patientContacts?.find(
    (contact) => contact.label.toLowerCase() === "secondary"
  );

  const primary_number = primaryContact?.number || null;
  const secondary_number = secondaryContact?.number || null;

  const accountId = sessionStorage.getItem("acc_id");
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id;

  const patientId = sessionStorage.getItem("_pt_id");

  const [isSectionOpen, setIsSectionOpen] = useState(true);
  const [details, setDetails] = useState("");
  const ccmValue = sessionStorage.getItem("ccm");
  const rpmValue = sessionStorage.getItem("rpm");
  const isCCM = ccmValue === "true";
  const isRPM = rpmValue === "true";

  const {
    data: patient,
    error,
    isLoading,
    refetch,
  } = useQuery(
    ["patient-general-details", patientId],
    () => getPatientGeneralDetails(patientId),
    { enabled: !!patientId, staleTime: 5 * 60 * 1000 }
  );

  const user = patient?.user;
  const monitoring_time = patient?.monitoring_time_current_month;
  const handleClick = () => {
    setIsSectionOpen(!isSectionOpen);
  };

  if (isLoading) return <Spinner />;
  if (error)
    return <Reload message="Could not load details" onReload={refetch} />;

  return (
    <div className={styles.details_grid}>
      <div>
        <p className={styles.label}>Patient Name</p>
        <p className={styles.label_value}>
          {user?.first_name + " " + user?.last_name}
        </p>
      </div>
      <div>
        <p className={styles.label}>Primary Phone</p>
        <p className={styles.label_value}>
          {/* <strong>{user.primary_phone ?? "_"}</strong> */}
          <strong>{patient?.user?.primary_phone ?? "_"}</strong>
        </p>
      </div>
      <div>
        <p className={styles.label}>Provider</p>
        <p className={styles.label_value}>
          <strong>
            {patient?.provider?.first_name} {patient?.provider?.last_name}
          </strong>
        </p>
      </div>
      <div>
        <p className={styles.label}>Email</p>
        <p className={styles.label_value}>
          <strong>{user?.email ?? "_"}</strong>
        </p>
      </div>
      {patientContacts?.map((_contact) => (
        <div>
          <p className={styles.label}>{_contact.label}</p>
          <p className={styles.label_value}>
            {/* <strong>{user.secondary_phone ?? "_"}</strong> */}
            <strong>{_contact?.number ?? "_"}</strong>
          </p>
        </div>
      ))}
      <div>
        <p className={styles.label}>Date of Birth</p>
        <p className={styles.label_value}>
          <strong>{formatDob(patient?.user?.dob) ?? "_"}</strong>
        </p>
      </div>
      <div>
        <p className={styles.label}>Gender</p>
        <p className={styles.label_value}>
          <strong>{user?.gender ?? "_"}</strong>
        </p>
      </div>
      {isRPM && (
        <div>
          <p className={styles.label}>Total RPM Time</p>
          <p className={styles.label_value}>
            <strong>{monitoring_time?.formatted_rpm_time ?? "_"}</strong>
          </p>
        </div>
      )}

      {isCCM && (
        <div>
          <p className={styles.label}>Total CCM Time</p>
          <p className={styles.label_value}>
            <strong>{monitoring_time?.formatted_ccm_time ?? "_"}</strong>
          </p>
        </div>
      )}

      <div>
        <p className={styles.label}>Case Manager</p>
        <p className={styles.label_value}>
          <strong>
            {patient?.case_manager?.first_name}{" "}
            {patient?.case_manager?.last_name}
          </strong>
        </p>
      </div>
      <div>
        <p className={styles.label}>Monthly Days of Readings</p>
        <p className={styles.label_value}>
          <strong>
            {patient?.current_month_reading_days ?? "_"}
            {/* Readings this Month */}
          </strong>
        </p>
      </div>
      <div>
        <p className={styles.label}>Preferred Language</p>
        <p className={styles.label_value}>
          <strong>{patient?.preferred_language ?? "-"}</strong>
        </p>
      </div>
    </div>
  );
};

export default GeneralDetails;
